
import React from 'react';
import { CategoryType } from '../../types';

interface CategorySelectorProps {
  category: CategoryType;
  setCategory: (cat: CategoryType) => void;
  availableCategories: CategoryType[];
}

const CategorySelector: React.FC<CategorySelectorProps> = ({ category, setCategory, availableCategories }) => {
  return (
    <div className="space-y-1 flex-1">
      <label className="block text-[9px] font-black text-slate-500 dark:text-slate-400 uppercase tracking-widest ml-1">Categoria</label>
      <div className="relative">
        <select 
          value={category} 
          onChange={(e) => setCategory(e.target.value as CategoryType)} 
          className="w-full bg-slate-100 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg px-3 py-2.5 text-xs font-bold text-slate-800 dark:text-slate-100 outline-none focus:ring-4 focus:ring-blue-500/10 transition-all appearance-none shadow-sm pr-8"
        >
          {availableCategories.map(cat => <option key={cat} value={cat}>{cat}</option>)}
        </select>
        <i className="fa-solid fa-chevron-down absolute right-3 top-1/2 -translate-y-1/2 text-slate-500 pointer-events-none text-[9px]"></i>
      </div>
    </div>
  );
};

export default CategorySelector;
